module.exports = __webpack_public_path__ + "media/products_of_the_shelf.b30ed96f.webm";